<template>
  <section>
    <el-date-picker
      v-model="dateRange"
      :clearable="false"
      type="daterange"
      class="fixed_date_picker"
      range-separator="至"
      start-placeholder="開始日期"
      end-placeholder="結束日期"
    />

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`商品銷售報告-${date_from}-${date_to}.xls`"
            :fields="productFields"
            :data="productTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="bar"
          height="350"
          :options="productOptions"
          :series="product"
          :key="'product' + chartKey"
        ></apexchart>
        <b-table
          ref="refProductTable"
          class="position-relative mt-2"
          :items="productTableData"
          responsive
          :fields="productTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
        </b-table>
        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ productDataMeta.of }}個記錄中，正在顯示
                {{ productDataMeta.from }} 至
                {{ productDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="productCurrentPage"
                :total-rows="totalProduct"
                :per-page="productPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`營收報告-${date_from}-${date_to}.xls`"
            :fields="monthlySalesFields"
            :data="monthlySalesTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="line"
          height="350"
          :options="monthlySalesOptions"
          :series="monthly_sales"
          :key="'Monthly' + chartKey"
        ></apexchart>

        <b-table
          ref="refMonthlyTable"
          class="position-relative mt-2"
          :items="monthlySalesTableData"
          responsive
          :fields="monthlySalesTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
          <!-- Column: Date -->
          <template #cell(Date)="data">
            {{ data.item.year }}年{{ data.item.month }}月
          </template>
        </b-table>

        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ monthlyDataMeta.of }}個記錄中，正在顯示
                {{ monthlyDataMeta.from }} 至
                {{ monthlyDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="monthlyCurrentPage"
                :total-rows="totalMonthly"
                :per-page="monthlyPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`分類成本報告-${date_from}-${date_to}.xls`"
            :fields="costFields"
            :data="costTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="bar"
          height="350"
          :options="costOptions"
          :series="cost"
          :key="'Cost' + chartKey"
        ></apexchart>

        <b-table
          ref="refCostTable"
          class="position-relative mt-2"
          :items="costTableData"
          responsive
          :fields="costTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
        </b-table>
        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ costDataMeta.of }}個記錄中，正在顯示
                {{ costDataMeta.from }} 至
                {{ costDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="costCurrentPage"
                :total-rows="totalCost"
                :per-page="costPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

    <div class="mt-3">
      <b-card>
        <div class="d-flex justify-content-end">
          <download-excel
            class="btn btn-primary mb-1"
            :name="`師傅工資報告-${date_from}-${date_to}.xls`"
            :fields="salaryFields"
            :data="salaryTableData"
          >
            導出Excel
          </download-excel>
        </div>
        <apexchart
          v-if="isInit"
          type="bar"
          height="350"
          :options="salaryOptions"
          :series="salary"
          :key="'salary' + chartKey"
        ></apexchart>

        <b-table
          ref="refsalaryTable"
          class="position-relative mt-2"
          :items="salaryTableData"
          responsive
          :fields="salaryTableColumns"
          show-empty
          empty-text="未找到匹配的記錄"
        >
         
        </b-table>

        <div class="mx-2 mt-1 mb-2">
          <b-row>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-start"
            >
              <span class="text-muted"
                >在{{ salaryDataMeta.of }}個記錄中，正在顯示
                {{ salaryDataMeta.from }} 至
                {{ salaryDataMeta.to }}個記錄</span
              >
            </b-col>
            <b-col
              cols="12"
              sm="6"
              class="d-flex align-items-center justify-content-center justify-content-sm-end"
            >
              <b-pagination
                v-model="salaryCurrentPage"
                :total-rows="totalSalary"
                :per-page="salaryPerPage"
                first-number
                last-number
                class="mb-0 mt-1 mt-sm-0"
                prev-class="prev-item"
                next-class="next-item"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </b-col>
          </b-row>
        </div>
      </b-card>
    </div>

  </section>
</template>
          
  <script>
import {
  BCard,
  BCardBody,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BButton,
  BTable,
  BMedia,
  BAvatar,
  BLink,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
} from "bootstrap-vue";
import { formatCurrency } from "@core/utils/filter";
import vSelect from "vue-select";
import axiosIns from "@/libs/axios";
import {
  ref,
  onMounted,
  watch,
  computed,
  onUnmounted,
} from "@vue/composition-api";
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);

export default {
  components: {
    BCard,
    BCardBody,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    vSelect,
  },
  data() {
    return {
      dateRange: [],
    };
  },
  watch: {
    dateRange: {
      handler() {
        [this.date_from, this.date_to] = this.dateRange;
        if (typeof this.date_from === "object") {
          this.date_from = this.getFormatedDate(this.date_from);
          this.date_to = this.getFormatedDate(this.date_to);
        }
      },
    },
  },
  created() {
    const last_year = new Date(
      new Date().setFullYear(new Date().getFullYear() - 1)
    );
    this.dateRange = [
      this.getFormatedDate(last_year),
      this.getFormatedDate(new Date()),
    ];
  },
  methods: {
    getFormatedDate(date) {
      const mm = date.getMonth() + 1; // getMonth() is zero-based
      const dd = date.getDate();

      return [
        date.getFullYear(),
        (mm > 9 ? "" : "0") + mm,
        (dd > 9 ? "" : "0") + dd,
      ].join("-");
    },
  },
  setup() {
    const loading = ref(false);
    // for chart series
    const product = ref([
      {
        name: "",
        data: [],
      },
    ]);
    const monthly_sales = ref([
      {
        name: "",
        data: [],
      },
    ]);
    const cost = ref([
      {
        name: "",
        data: [],
      },
    ]);
    const salary = ref([
      {
        name: "",
        data: [],
      },
    ]);

    const date_from = ref(null);
    const date_to = ref(null);

    const chartKey = ref(0);

    // for chart Options
    const productOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          // endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false,
      },
      title: {
        text: "商品銷售報告",
        align: "left",
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          // text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1,
      },
    });
    
    const monthlySalesOptions = ref({
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: false,
        },
      },
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "營收報告",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: [],
      },
    });
    
    const costOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          // endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false,
      },
      title: {
        text: "分類成本報告",
        align: "left",
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          // text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1,
      },
    });
    
    const salaryOptions = ref({
      chart: {
        toolbar: {
          show: false,
        },
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "40%",
          colors: {
            categories: ["#f00", "#0f0", "#00f"],
          },
          // endingShape: 'rounded'
        },
      },
      dataLabels: {
        enabled: false,
      },
      title: {
        text: "師傅工資報告",
        align: "left",
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"],
      },
      xaxis: {
        categories: [],
      },
      yaxis: {
        title: {
          // text: '$ (thousands)'
        },
      },
      fill: {
        opacity: 1,
      },
    });
    

    const productTableData = ref(null);
    const productTableData_original = ref(null);
    const productTableColumns = [
      { key: "product_name", stickyColumn: true, label: "商品名稱", sortable: true },
      { key: "total_amount", label: "總數", sortable: true },
      // { key: "total_paid", label: "已付", sortable: true, formatter: formatCurrency },
      { key: "total_profit", label: "總營利", sortable: true },
      { key: "profit_margin", label: "營利率", sortable: true },
    ];
    // for excel
    const productFields = ref({
      商品名稱: `product_name`,
      總數: `total_amount`,
      // 已付: `total_paid`,
      總營利: `total_profit`,
      營利率: `profit_margin`,
    });

    const monthlySalesTableData = ref(null);
    const monthlySalesTableData_original = ref(null);
    const monthlySalesTableColumns = [
      { key: "Date", label: "日期", sortable: true },
      { key: "total_amount", label: "總數", sortable: true },
      { key: "total_paid", label: "已付", sortable: true, formatter: formatCurrency },
      { key: "total_due", label: "欠款", sortable: true },
    ];
    // for excel
    const monthlySalesFields = ref({
      年份: `year`,
      月份: `month`,
      總數: "total_amount",
      已付: "total_paid",
      欠款: "total_due",
    });


    const costTableData = ref(null);
    const costTableData_original = ref(null);
    const costTableColumns = [
      { key: "product_name", stickyColumn: true, label: "商品名稱", sortable: true },
      { key: "cost", label: "成本", sortable: true },
    ];
    // for excel
    const costFields = ref({
      商品名稱: `product_name`,
      成本: `cost`,
    });


    const salaryTableData = ref(null);
    const salaryTableData_original = ref(null);
    const salaryTableColumns = [
      { key: "name", stickyColumn: true, label: "員工名稱", sortable: true },
      { key: "total_salary", label: "工資", sortable: true, formatter: formatCurrency },
    ];
    // for excel
    const salaryFields = ref({
      員工名稱: `name`,
      工資: `total_salary`,
    });
    
    
    // for per page
     const refetchTbData = ( meta, perPage, current, target, original) => {
      const min = Number(meta.value.from - 1);
      const max = Number(perPage.value * current.value - 1);

        target.value = original.value.filter(
          (ele, index) => index >= min && index <= max
        );
    };

    const refProductTable = ref(null);
    const productCurrentPage = ref(1);
    const productPerPage = ref(10);
    const totalProduct = ref(0);

    // showing count of per page item 
    const productDataMeta = computed(() => {
      const localItemsCount = refProductTable.value
        ? refProductTable.value.localItems.length
        : 0;
      return {
        from:
          productPerPage.value * (productCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          productPerPage.value * (productCurrentPage.value - 1) + localItemsCount,
        of: totalProduct.value,
      };
    });

    const refMonthlyTable = ref(null);
    const monthlyCurrentPage = ref(1);
    const monthlyPerPage = ref(10);
    const totalMonthly = ref(0);

    // showing count of per page item 
    const monthlyDataMeta = computed(() => {
      const localItemsCount = refMonthlyTable.value
        ? refMonthlyTable.value.localItems.length
        : 0;
      return {
        from:
          monthlyPerPage.value * (monthlyCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          monthlyPerPage.value * (monthlyCurrentPage.value - 1) + localItemsCount,
        of: totalMonthly.value,
      };
    });



    const refCostTable = ref(null);
    const costCurrentPage = ref(1);
    const costPerPage = ref(10);
    const totalCost = ref(0);

    // showing count of per page item 
    const costDataMeta = computed(() => {
      const localItemsCount = refCostTable.value
        ? refCostTable.value.localItems.length
        : 0;
      return {
        from:
          costPerPage.value * (costCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
         costPerPage.value * (costCurrentPage.value - 1) + localItemsCount,
        of: totalCost.value,
      };
    });

    const refSalaryTable = ref(null);
    const salaryCurrentPage = ref(1);
    const salaryPerPage = ref(10);
    const totalSalary = ref(0);

    // showing count of per page item 
    const salaryDataMeta = computed(() => {
      const localItemsCount = refSalaryTable.value
        ? refSalaryTable.value.localItems.length
        : 0;
      return {
        from:
          salaryPerPage.value * (salaryCurrentPage.value - 1) +
          (localItemsCount ? 1 : 0),
        to:
          salaryPerPage.value * (salaryCurrentPage.value - 1) + localItemsCount,
        of: totalSalary.value,
      };
    });

    
    // for chart option - xaxis label
    const getYearMonthLabel = (target) => {
      return [
        ...new Set(
          target.map((ele) => {
            return ele.year + "年" + ele.month + "月";
          })
        ),
      ];
    };

    // handle Simple bar chart series
    const getSimpleBarChartSeries = (target, arr, key, amountKey) => {
      // Map each unique category name
      var newArr = new Set(arr.map((ele) => ele[key]));
      target.value = [];
      newArr.forEach((ele) => {
        // Initialize category object
        var Obj = {
          name: ele,
          data: [],
        };
        // Aggregate amounts for each category
        arr.forEach((item) => {
          if (item[key] === ele) {
            Obj.data.push(item[amountKey]);
          }
        });
        // Add to result
        target.value.push(Obj);
      });
    };

    // handle bar chart series
    const getBarChartSeries = (target, arr, key, amountKey) => {
      // 获取唯一分类
      var categories = new Set(arr.map((item) => item[key]));

      // 初始化目标数组
      target.value = [];

      categories.forEach((category) => {
        // 初始化分类对象
        var obj = {
          name: category,
          data: [],
        };

        // 获取月份范围
        var months = arr.map((item) => item.month).sort((a, b) => a - b);
        var minMonth = months[0];
        var maxMonth = months[months.length - 1];

        // 初始化data数组
        for (var i = minMonth; i <= maxMonth; i++) {
          obj.data.push(0);
        }

        // 累加数据
        arr.forEach((item) => {
          if (item[key] === category) {
            obj.data[item.month - minMonth] = item[amountKey] || 0;
          }
        });

        // 添加到结果
        target.value.push(obj);
      });
    };


    // v-if init true load chart 
    const isInit = ref(false);

    const refetchData = () => {
      loading.value = true;
      axiosIns
        .get("/finance/analysis/", {
          params: {
            date_from: date_from.value,
            date_to: date_to.value,
          },
        })
        .then((response) => {
          loading.value = false;
          productTableData.value = response.data.product_data;
          monthlySalesTableData.value = response.data.monthly_sales;
          costTableData.value = response.data.cost_data;
          salaryTableData.value = response.data.salary_data;

          productTableData_original.value = response.data.product_data;
          monthlySalesTableData_original.value = response.data.monthly_sales;
          costTableData_original.value = response.data.cost_data;
          salaryTableData_original.value = response.data.salary_data;

          // x label
          productOptions.value.xaxis.categories =
            response.data.product_data.map((ele) => {
                return ele.product_name;
            });
            console.log('productOptions.value.xaxis.categories',productOptions.value.xaxis.categories)

          monthlySalesOptions.value.xaxis.categories = getYearMonthLabel(
            response.data.monthly_sales
          );

          costOptions.value.xaxis.categories  =
            response.data.cost_data.map((ele) => {
              return ele.product_name;
            });

          salaryOptions.value.xaxis.categories  =
            response.data.salary_data.map((ele) => {
              return ele.name;
            });


          // series
          product.value[0].name = "商品"
          product.value[0].data = response.data.product_data.map(
            (ele) => {
              return ele.total_amount;
            }
          );

          monthly_sales.value[0].data = response.data.monthly_sales.map(
            (ele) => {
              return ele.total_amount;
            }
          );

          cost.value[0].name = "分類成本"
          cost.value[0].data = response.data.cost_data.map(
            (ele) => {
              return ele.cost;
            }
          );

          salary.value[0].name = "員工"
          salary.value[0].data = response.data.salary_data.map(
            (ele) => {
              return ele.total_salary;
            }
          );

          // total
          totalProduct.value = productTableData.value.length;
          totalMonthly.value = monthlySalesTableData.value.length;
          totalCost.value = costTableData.value.length;
          totalSalary.value = salaryTableData.value.length;
         
          refetchTbData(
            productDataMeta,
            productPerPage,
            productCurrentPage,
            productTableData,
            productTableData_original
          );

          refetchTbData(
            monthlyDataMeta,
            monthlyPerPage,
            monthlyCurrentPage,
            monthlySalesTableData,
            monthlySalesTableData_original
          );
          refetchTbData(
            costDataMeta,
            costPerPage,
            costCurrentPage,
            costTableData,
            costTableData_original
          );

          refetchTbData(
            salaryDataMeta,
            salaryPerPage,
            salaryCurrentPage,
            salaryTableData,
            salaryTableData_original
          );

          isInit.value = true;
          chartKey.value += 1;
        })
        .catch((error) => {
          console.log(error);
          loading.value = false;
        });
    };

    watch([date_from, date_to, productCurrentPage, 
    monthlyCurrentPage, costCurrentPage, salaryCurrentPage
  ], () => {
      refetchData();
    });

    onMounted(() => {
      // refetchData();
    });

    return {
      product,
      monthly_sales,
      cost,
      salary,

      date_from,
      date_to,

      productOptions,
      monthlySalesOptions,
      costOptions,
      salaryOptions,

      refetchData,
      loading,
      isInit,
      chartKey,

      productTableData,
      productFields,
      productTableColumns,

      monthlySalesTableData,
      monthlySalesFields,
      monthlySalesTableColumns,

      costTableData,
      costFields,
      costTableColumns,

      salaryTableData,
      salaryFields,
      salaryTableColumns,

      refProductTable,
      totalProduct,
      productDataMeta,
      productPerPage,
      productCurrentPage,

      refMonthlyTable,
      totalMonthly,
      monthlyDataMeta,
      monthlyPerPage,
      monthlyCurrentPage,

      refCostTable,
      totalCost,
      costDataMeta,
      costPerPage,
      costCurrentPage,

      refSalaryTable,
      totalSalary,
      salaryDataMeta,
      salaryPerPage,
      salaryCurrentPage,
    };
  },
};
</script>
          
<style lang="scss" scoped>
.apexcharts-toolbar {
  display: none;
}
.fixed_date_picker {
  position: fixed;
  top: 7.2rem;
  z-index: 2;
}
</style>
          
      <style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@/assets/scss/variables/_variables.scss";
</style>
          